'use strict';

var React = require('react');

class Day extends React.Component {
    render() {
        var cx = '';

        if (this.props.day.classes) {
            cx = this.props.day.classes;
        }

        if (this.props.day.isBooked) {
            cx += ' is-booked';
        } else {
            cx += ' is-available';
        }

        if (this.props.day.isSwitchDay) {
            cx += ' is-switch-day';
        }
        return (
            <div className={cx}>
                <span className='day-number'>{this.props.day.day.date()}</span>
            </div>
        );
    }
}

Day.defaultProps = {
    classes: ''
} 

module.exports = Day;



// WEBPACK FOOTER //
// ./src/components/Day.js